<script lang="ts">
	import Avatar from '$lib/components/Avatar/Avatar.svelte';
	import Icon from '$lib/components/Icon/Icon.svelte';
	import { getHubStores } from '$lib/stores/hubStores';
	import { openComposer } from '$lib/components/TextEditor/PostComposer/composerStore';
	import { _ } from 'svelte-i18n';
	import type { Collection } from '$lib/types/Collections';

	export let currentCollection: Collection;
	const { user } = getHubStores();
</script>

<div class="postBox">
	<button
		type="button"
		class="share"
		on:click={() => openComposer({ collection: currentCollection })}>
		<Avatar url={$user.avatar_url || ''} name={$user.name} />
		<div style="margin-inline-start: 5px;">
			{$_('common.what.do.you.want.to.share')}
		</div>
	</button>
	<div>
		<div class="buttons">
			<button
				type="button"
				on:click={() => openComposer({ collection: currentCollection, initBlock: 'link' })}>
				<Icon icon="link" clickable size="26" color="rgb(83, 90, 99)" />
				{$_('common.share.link')}
			</button>
			<button
				type="button"
				on:click={() => openComposer({ collection: currentCollection, initBlock: 'document' })}>
				<Icon icon="upload" clickable size="26" color="rgb(83, 90, 99)" />
				{$_('common.upload.file')}
			</button>
		</div>
	</div>
</div>

<style>
	div {
		display: flex;
		align-items: center;
		block-size: 100%;
	}

	button {
		display: flex;
		align-items: center;
		padding: 0;
		border-width: 0;
		background-color: transparent;
		cursor: pointer;
	}

	.postBox {
		inline-size: 100%;
		margin-block-start: var(--gutterLarge);
		padding: var(--gutterMedium);
		border: 1px solid rgb(240 240 240);
		background-color: white;
		box-shadow: 0 1px 2px 0 rgb(0 0 0 / 6%);
		color: var(--grayDark);
		cursor: pointer;
	}

	.share {
		flex: 1;
	}

	.buttons {
		gap: 15px;
	}

	.buttons > button {
		font-size: var(--fontSizeSmaller);
	}

	.buttons > button:hover {
		color: rgb(83 90 99);
	}

	@media screen and (max-width: 575px) {
		.postBox {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			block-size: 140px;
		}

		.share {
			margin-inline-end: auto;
		}

		.buttons {
			gap: 50px;
		}
	}
</style>
